import { Input } from "@design-system/Input/Input";
import { SearchIcon } from "@icons";
import { allSizes } from "./InputPlayground.lib";
import { VariantGrid, VariantItem } from "./playgroundControls";

/**
 * Every drawn Figma variant, one stage each, so the component can be
 * compared with node 3063:396 side by side. Hover/active states are live;
 * disabled and error are props.
 */
export const InputMatrix = () => (
    <>
        <VariantGrid title="Primary · sizes" columns="wide">
            {allSizes.map((size) => (
                <VariantItem key={size} label={`size="${size}"`}>
                    <Input
                        size={size}
                        defaultValue="Input"
                        leftIcon={<SearchIcon />}
                    />
                </VariantItem>
            ))}
        </VariantGrid>
        <VariantGrid title="Primary · states (md)" columns="wide">
            <VariantItem label="empty">
                <Input placeholder="Placeholder" />
            </VariantItem>
            <VariantItem label="filled">
                <Input defaultValue="Input" />
            </VariantItem>
            <VariantItem label="disabled">
                <Input
                    defaultValue="Input"
                    disabled
                    leftIcon={<SearchIcon />}
                />
            </VariantItem>
            <VariantItem label="readOnly">
                <Input defaultValue="Input" readOnly />
            </VariantItem>
            <VariantItem label="invalid empty">
                <Input
                    placeholder="Placeholder"
                    invalid
                    leftIcon={<SearchIcon />}
                />
            </VariantItem>
            <VariantItem label="invalid">
                <Input defaultValue="Input" invalid />
            </VariantItem>
            <VariantItem label="clearable">
                <Input defaultValue="Clear me" clearable />
            </VariantItem>
            <VariantItem label="type=search">
                <Input
                    type="search"
                    defaultValue="Search"
                    clearable
                    leftIcon={<SearchIcon />}
                />
            </VariantItem>
        </VariantGrid>
        <VariantGrid title="Ghost (md)" columns="wide">
            <VariantItem label="empty">
                <Input variant="ghost" placeholder="Placeholder" />
            </VariantItem>
            <VariantItem label="filled · icon">
                <Input
                    variant="ghost"
                    defaultValue="Input"
                    leftIcon={<SearchIcon />}
                />
            </VariantItem>
            <VariantItem label="fontSize={12}">
                <Input
                    variant="ghost"
                    fontSize={12}
                    defaultValue="Input"
                    leftIcon={<SearchIcon />}
                />
            </VariantItem>
            <VariantItem label="disabled">
                <Input variant="ghost" defaultValue="Input" disabled />
            </VariantItem>
            <VariantItem label="readOnly">
                <Input variant="ghost" defaultValue="Input" readOnly />
            </VariantItem>
        </VariantGrid>
        <VariantGrid title="Accent (md)" columns="wide">
            <VariantItem label="empty">
                <Input variant="accent" placeholder="Placeholder" />
            </VariantItem>
            <VariantItem label="filled · icon">
                <Input
                    variant="accent"
                    defaultValue="Input"
                    leftIcon={<SearchIcon />}
                />
            </VariantItem>
            <VariantItem label="disabled">
                <Input
                    variant="accent"
                    defaultValue="Input"
                    disabled
                    leftIcon={<SearchIcon />}
                />
            </VariantItem>
            <VariantItem label="readOnly">
                <Input variant="accent" defaultValue="Input" readOnly />
            </VariantItem>
        </VariantGrid>
    </>
);
